"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const gatsby_1 = require("gatsby");
const _theme_1 = require("@theme");
var toolWidth = 84; // Component
var QuickLinksBar = function QuickLinksBar(_ref) {
    var links = _ref.links, className = _ref.className, toolCount = _ref.toolCount;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(Items, Object.assign({
        className: className + " shiftable"
    }, {
        toolCount: toolCount
    }), /*#__PURE__*/ react_1.default.createElement(Spacer, null), links.map(function (item) {
        return /*#__PURE__*/ react_1.default.createElement(Item, {
            key: item.label,
            active: item.active
        }, item.to && /*#__PURE__*/ react_1.default.createElement(StyledLink, {
            to: item.to
        }, item.label), item.onClick !== undefined && /*#__PURE__*/ react_1.default.createElement(Label, {
            onClick: function onClick() {
                return item.onClick && item.onClick();
            }
        }, item.label));
    }), /*#__PURE__*/ react_1.default.createElement(Spacer, null)));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "QuickLinksBar__Wrapper",
    componentId: "sc-71yrwp-0"
})(["position:relative;display:flex;justify-content:center;width:100%;height:100%;overflow-y:hidden;overflow-x:auto;-webkit-overflow-scrolling:touch;&::-webkit-scrollbar{width:0px;height:0px;}"]);
var Items = styled_components_1.default.ul.withConfig({
    displayName: "QuickLinksBar__Items",
    componentId: "sc-71yrwp-1"
})(["z-index:1;position:relative;box-sizing:content-box;display:grid;grid-auto-flow:column;width:fit-content;max-width:100%;height:100%;padding:0 12px;@media only screen and (min-width:", "){", "}"], _theme_1.breakpoint.tablet, function (props) {
    return props.toolCount && props.toolCount > 0 && "\n      padding: 0 calc(" + props.toolCount * toolWidth + "px + 20px);\n    ";
});
var Spacer = styled_components_1.default.div.withConfig({
    displayName: "QuickLinksBar__Spacer",
    componentId: "sc-71yrwp-2"
})(["background:transparent;width:12px;height:100%;&:last-of-type{width:64px;}@media only screen and (min-width:", "){width:20px !important;}"], _theme_1.breakpoint.tablet);
var Item = styled_components_1.default.li.withConfig({
    displayName: "QuickLinksBar__Item",
    componentId: "sc-71yrwp-3"
})(["position:relative;display:flex;justify-content:center;align-items:center;height:100%;white-space:nowrap;&::after{position:absolute;left:50%;bottom:0px;width:100%;height:2px;background-color:", ";transform-origin:center;transform:translate3d(-50%,0,0) scaleX(", ");transition:transform 0.3s cubic-bezier(0.645,0.045,0.355,1);will-change:transform;content:'';}@media only screen and (min-width:", "){&:hover::after{transform:translate3d(-50%,0,0) scaleX(1);}}"], _theme_1.palette.brown, function (props) {
    return props.active ? 1 : 0;
}, _theme_1.breakpoint.tablet);
var ItemStyle = styled_components_1.css(["position:relative;display:flex;align-items:center;height:100%;padding:0 12px;", " cursor:pointer;@media only screen and (min-width:", "){padding:0 20px;}"], _theme_1.type.labelSmall, _theme_1.breakpoint.tablet);
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "QuickLinksBar__StyledLink",
    componentId: "sc-71yrwp-4"
})(["", " color:", ";"], ItemStyle, _theme_1.palette.ink);
var Label = styled_components_1.default.div.withConfig({
    displayName: "QuickLinksBar__Label",
    componentId: "sc-71yrwp-5"
})(["", " color:", ";"], ItemStyle, _theme_1.palette.ink); // Typing
exports.default = QuickLinksBar;
